/* eslint-disable no-console */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Button } from 'antd';
import InputSelectField from '../form-helpers/InputSelectField';
import { FormInputArea } from '../form-helpers/FormField';
import LoadingSpinner from '../../common/LoadingSpinner';
import { errorNotification } from '../../../utils/notification-helpers';
import SharedWithList from './SharedWithList';

const data = [
  {label: 'Selection 1', value: 'Selection 1'},
  {label: 'Selection 2', value: 'Selection 2'},
  {label: 'Selection 3', value: 'Selection 3'},
  {label: 'Selection 4', value: 'Selection 4'},
]

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  }
}

function FamilyHistoryForm({ onSubmitBtnText, onSubmitForm, dataMedicalHistory }) {
  const { t } = useTranslation(['common', 'medical-history']);

  const FormSchema = useMemo(
    () =>
      Yup.object().shape({
        family_history: Yup.string().required(t('form.error.required'))
      }),
    [t]
  );

  const initialValues = {
    family_history: dataMedicalHistory && dataMedicalHistory.family_history ? dataMedicalHistory.family_history : '',
  };

  return (
    <div style={{ width: '100%', textAlign: 'left' }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={FormSchema}
        onSubmit={async (values) => {
          const dataForm = dataMedicalHistory ?? {};
          dataForm.family_history = values.family_history
          console.log("dataForm", dataForm)
          onSubmitForm(dataForm)
        }}
      >
        {({ isSubmitting, isValid, setFieldValue }) => {
          return (
            <Form>
              <fieldset disabled={isSubmitting}>
                <FormInputArea
                  name="family_history"
                  style={{ width: '100%', padding: '3%' }}
                  formItemLayout={formItemLayout}
                  onChange={(e) => setFieldValue("family_history", e.target.value)}
                  rows={6}
                />
                {/* <InputSelectField
                  name="enterFamilyHistory"
                  label={t('medical-history:familyHistory.form.enterFamilyHistory.label')}
                  placeholder={t('medical-history:familyHistory.form.enterFamilyHistory.placeholder')}
                  options={data}
                />
                <Box>
                  <SharedWithList
                    title={t('medical-history:familyHistory.form.yourFamilyHistory.label')}
                    emptyTitle={t('medical-history:familyHistory.form.yourFamilyHistory.noSelected')}
                    list={[]}
                    onRemove={onRemove} />
                </Box> */}
                <Box paddingTop={15}>
                  <Button
                    disabled={isSubmitting || !isValid}
                    loading={isSubmitting}
                    htmlType="submit"
                    type="primary"
                    size="large"
                    block
                  >
                    {isSubmitting ? <LoadingSpinner position="full" transparent={false} /> : onSubmitBtnText}
                  </Button>
                </Box>
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

FamilyHistoryForm.defaultProps = {
  onSubmitBtnText: 'Save & Update',
};

const { string, func } = PropTypes;

FamilyHistoryForm.propTypes = {
  onSubmitBtnText: string,
  onSubmitForm: func.isRequired,
  dataMedicalHistory: PropTypes.objectOf(PropTypes.any).isRequired
};

export default FamilyHistoryForm;
